/** 
 * TOGGLE-BUTTON
 */


import { faCheck } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { connect } from "react-redux"
import { Session } from "@/redux/_session.types"

interface StateProps{
  _session : Session
}

interface OwnProps{
  disabled?: boolean
  ariaLabel?: string
  color? : string
  text? : string
  isActive : boolean
  onToogle : Function
}

type Props = StateProps & OwnProps

function ToggleButton(props: Props) {

  return (
    <div className="toggle-button _hover"
      role="switch"
      aria-checked={props.isActive}
      aria-disabled={props.disabled}
      aria-label={props.ariaLabel ?? props.text}
      tabIndex={props.disabled ? -1 : 0}
      onKeyDown={event => {
        if (!props.disabled && (event.key === " " || event.key === "Enter")) {
          event.preventDefault()
          props.onToogle()
        }
      }}
      onClick={() => !props.disabled && props.onToogle()}
      style={{ backgroundColor : props.isActive ? (props.color ? props.color : props._session.accountColors.active) : "" }}>

      { props.text &&
      <div className={"toggle-button-text flex" + (props.isActive ? " toggle-button-active" : "")}>
        {props.text}
      </div>
      }

      <div className={"flex toggle-button-circle" + (props.isActive ? " toggle-button-active" : "")}>
        { props.isActive && <FontAwesomeIcon icon={faCheck}/> }
      </div>

    </div>
  )
}

const mapStateToProps = state => ({
  _session : state._session
})

export default connect(mapStateToProps)(ToggleButton)